import { useLocation } from '@remix-run/react';
import { useEffect } from 'react';

const useStructuredData = (data: {}) => {
  const location = useLocation();

  useEffect(() => {
    const scriptElement = document.createElement('script');
    scriptElement.type = 'application/ld+json';
    scriptElement.innerHTML = JSON.stringify(data);

    document.head.appendChild(scriptElement);

    return () => {
      document.head.removeChild(scriptElement);
    };
  }, [location, data]);
};

export default useStructuredData;
